// extracted by mini-css-extract-plugin
export default {"container":"SW-z","title":"TW-z","link":"UW-z"};